import React from "react";
import { BellOff } from "lucide-react";
import { PushDevice } from "@myapp/contract";
import { IconButton } from "../../../shared/ui/icons/IconButton/IconButton";
import { formatDeviceLabel } from "../lib/formatDeviceLabel";

interface Props {
  device: PushDevice;
  onRevoke: (device: PushDevice) => void;
  disabled?: boolean;
}

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

export const PushDeviceRow: React.FC<Props> = ({ device, onRevoke, disabled }) => {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg bg-[#F6F6F6] px-3 py-2">
      <div className="min-w-0">
        <p className="truncate text-[14px] font-['PT_Sans'] text-primary">
          {formatDeviceLabel(device.userAgent)}
        </p>
        <p className="text-[12px] font-['PT_Sans'] text-gray-500">
          Zuletzt aktiv: {formatDate(device.lastSeenAt)}
        </p>
      </div>
      <IconButton
        icon={<BellOff size={16} />}
        onClick={() => onRevoke(device)}
        disabled={disabled}
        aria-label="Gerät deaktivieren"
      />
    </div>
  );
};
